import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Plus from "mdi-material-ui/Plus";

import TitleBar from "../../components/TitleBar";
import TitleBarTitle from "../../components/TitleBarTitle";
import TableCellLink from "../../components/TableCellLink";
import TitleBarButton from "../../components/TitleBarButton";
import DataTable from "../../components/DataTable";
import Admin from "../../components/Admin";
import DeviceProfileStore from "../../stores/DeviceProfileStore";
import { withStyles } from "@material-ui/core/styles";
import { tableSortStyles, bindTableSortHandlers } from "../../classes/tableSort";

const styles = {
    ...tableSortStyles,
};

class ListDeviceProfiles extends Component {
  constructor() {
    super();

    this.getPage = this.getPage.bind(this);
    this.getRow = this.getRow.bind(this);
    bindTableSortHandlers(this);

    this.state = {
        orderBy:null,
        order:null
    }
  }

  getPage(limit, offset, callbackFunc) {
    DeviceProfileStore.list({limit, offset, orderBy: this.state.orderBy, order: this.state.order}, callbackFunc);
  }

  getRow(obj) {

    return(
      <TableRow
        key={obj.id}
        hover
      >
        <TableCellLink to={`/device-profiles/${obj.id}`}>{obj.name}</TableCellLink>
        <TableCell>{obj.id}</TableCell>
        <TableCell>{obj.networkServerName}</TableCell>
      </TableRow>
    );
  }

  render() {
    return(
      <Grid container spacing={4}>
        <TitleBar
          buttons={
            <Admin>
              <TitleBarButton
                label="Create"
                icon={<Plus />}
                to={`/device-profiles/create`}
              />
            </Admin>
          }
        >
          <TitleBarTitle title="Device-profiles" />
        </TitleBar>
        <Grid item xs={12}>
          <DataTable
            orderBy={this.state.orderBy}
            order={this.state.order}
            header={
              <TableRow>
                <TableCell {...this.makeCellSortProps('name')}>{this.makeSortLabel('name','Name')}</TableCell>
                <TableCell {...this.makeCellSortProps('id')}>{this.makeSortLabel('id','ID')}</TableCell>
                <TableCell {...this.makeCellSortProps('networkServerName')}>{this.makeSortLabel('networkServerName','Frequency plan')} </TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ListDeviceProfiles);
